import { render } from "./LeadsListModal.vue?vue&type=template&id=6fbba754"
import script from "./LeadsListModal.vue?vue&type=script&lang=js"
export * from "./LeadsListModal.vue?vue&type=script&lang=js"

import "./LeadsListModal.vue?vue&type=style&index=0&id=6fbba754&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__